
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function ServicesContent() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const categories = [
    { id: 'all', name: 'Tüm Hizmetler', icon: 'ri-apps-line' },
    { id: 'reporting', name: 'Raporlama', icon: 'ri-file-text-line' },
    { id: 'consulting', name: 'Danışmanlık', icon: 'ri-user-star-line' },
    { id: 'measurement', name: 'Ölçümleme', icon: 'ri-bar-chart-line' },
    { id: 'certification', name: 'Sertifikasyon', icon: 'ri-award-line' }
  ];

  const services = [
    {
      title: 'Sürdürülebilirlik Danışmanlığı',
      category: 'consulting',
      description: 'Sürdürülebilirlik stratejinizi geliştirmek ve uygulamak için kapsamlı danışmanlık hizmetleri sunuyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20sustainability%20consulting%20team%20in%20modern%20office%20with%20green%20plants%20and%20environmental%20charts%2C%20business%20strategy%20meeting&width=400&height=200&seq=501&orientation=landscape',
      features: ['Strateji Geliştirme', 'Stakeholder Analizi', 'Materality Analizi', 'Sürdürülebilirlik Roadmap'],
      duration: '8-12 hafta',
      benefits: ['Rekabet Avantajı', 'Risk Azaltma', 'Marka Değeri Artışı', 'Yatırımcı İlgisi']
    },
    {
      title: 'GRI Sürdürülebilirlik Raporu',
      category: 'reporting',
      description: 'Global Reporting Initiative standartlarına uygun sürdürülebilirlik raporları hazırlıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20team%20preparing%20GRI%20sustainability%20report%20in%20modern%20office%20environment%2C%20corporate%20responsibility%20documents%20and%20charts%20on%20table&width=400&height=200&seq=502&orientation=landscape',
      features: ['GRI Universal Standards', 'GRI Sector Standards', 'Materialize Analizi', 'Stakeholder Katılımı'],
      duration: '12-16 hafta',
      benefits: ['Uluslararası Tanınırlık', 'Şeffaflık', 'İnvestör Güveni', 'Sürdürülebilirlik Liderliği']
    },
    {
      title: 'TSRS Sürdürülebilirlik Raporu',
      category: 'reporting',
      description: 'Türkiye Sürdürülebilirlik Raporlama Standartları\'na uygun raporlama hizmetleri.',
      image: 'https://readdy.ai/api/search-image?query=Turkish%20sustainability%20reporting%20standards%20TSRS%20documentation%20with%20Turkish%20flag%20and%20business%20charts%2C%20professional%20corporate%20sustainability%20compliance&width=400&height=200&seq=503&orientation=landscape',
      features: ['TSRS Standartları', 'Yerel Uyumluluk', 'Türkçe Raporlama', 'Yasal Gereklilikler'],
      duration: '10-14 hafta',
      benefits: ['Yasal Uyumluluk', 'Yerel Tanınırlık', 'Borsa İstanbul Avantajı', 'Devlet Teşvikleri']
    },
    {
      title: 'CSRD Sürdürülebilirlik Raporu',
      category: 'reporting',
      description: 'AB\'nin Corporate Sustainability Reporting Directive gerekliliklerine uyum.',
      image: 'https://readdy.ai/api/search-image?query=European%20Union%20CSRD%20sustainability%20reporting%20directive%20compliance%20with%20EU%20flag%20and%20corporate%20documents%2C%20professional%20business%20environment&width=400&height=200&seq=504&orientation=landscape',
      features: ['CSRD Direktifi', 'ESRS Standartları', 'AB Uyumluluk', 'Digital Raporlama'],
      duration: '14-18 hafta',
      benefits: ['AB Pazarı Erişimi', 'Avrupa Kredibilite', 'Dijital Raporlama', 'Düzenleyici Uyum']
    },
    {
      title: 'ESG Danışmanlığı',
      category: 'consulting',
      description: 'Çevresel, Sosyal ve Kurumsal Yönetim kriterlerinde kapsamlı danışmanlık hizmetleri.',
      image: 'https://readdy.ai/api/search-image?query=ESG%20environmental%20social%20governance%20consulting%20with%20business%20professionals%20analyzing%20sustainability%20metrics%20and%20charts%20in%20modern%20office&width=400&height=200&seq=505&orientation=landscape',
      features: ['ESG Stratejisi', 'Risk Yönetimi', 'Performans Ölçümü', 'Yatırımcı İlişkileri'],
      duration: '8-12 hafta',
      benefits: ['Yatırım Çekme', 'Risk Azaltma', 'Operasyonel Verimlilik', 'Marka İtibarı']
    },
    {
      title: 'GAP Analizi',
      category: 'consulting',
      description: 'Mevcut durumunuz ile hedef sürdürülebilirlik standartları arasındaki farkları belirliyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Business%20gap%20analysis%20presentation%20with%20charts%20and%20graphs%20showing%20sustainability%20performance%20metrics%2C%20professional%20consulting%20environment&width=400&height=200&seq=506&orientation=landscape',
      features: ['Mevcut Durum Analizi', 'Hedef Belirleme', 'Eylem Planı', 'Öncelik Matrisi'],
      duration: '4-6 hafta',
      benefits: ['Net Roadmap', 'Kaynak Optimizasyonu', 'Hızlı Başlangıç', 'Maliyet Etkinliği']
    },
    {
      title: 'Ecovadis Danışmanlığı',
      category: 'certification',
      description: 'Ecovadis sürdürülebilirlik değerlendirmesinde yüksek skor almanızı sağlıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Ecovadis%20sustainability%20assessment%20gold%20medal%20award%20with%20business%20professionals%20celebrating%20achievement%20in%20corporate%20office%20environment&width=400&height=200&seq=507&orientation=landscape',
      features: ['Platform Yönetimi', 'Skor Optimizasyonu', 'Belge Hazırlığı', 'İyileştirme Planı'],
      duration: '6-10 hafta',
      benefits: ['Tedarik Zinciri Avantajı', 'B2B Kredibilite', 'İhracat Fırsatları', 'Müşteri Güveni']
    },
    {
      title: 'SBTi Danışmanlığı',
      category: 'certification',
      description: 'Science Based Targets initiative metodolojisi ile bilim temelli iklim hedefleri belirliyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Science%20based%20targets%20initiative%20SBTi%20climate%20goals%20with%20environmental%20scientists%20analyzing%20carbon%20data%20and%20climate%20charts&width=400&height=200&seq=508&orientation=landscape',
      features: ['Hedef Belirleme', 'SBTi Onayı', 'İklim Stratejisi', 'Net Zero Planlama'],
      duration: '8-12 hafta',
      benefits: ['İklim Liderliği', 'Yatırımcı İlgisi', 'Risk Yönetimi', 'İnovasyon Fırsatları']
    },
    {
      title: 'CDP Raporu',
      category: 'reporting',
      description: 'Carbon Disclosure Project raporlamasında A-List skorları elde etmenizi destekliyoruz.',
      image: 'https://readdy.ai/api/search-image?query=CDP%20Carbon%20Disclosure%20Project%20A-list%20scoring%20report%20with%20environmental%20data%20charts%20and%20climate%20performance%20metrics%20in%20professional%20setting&width=400&height=200&seq=509&orientation=landscape',
      features: ['CDP İklim', 'CDP Su', 'CDP Orman', 'A-List Stratejisi'],
      duration: '6-8 hafta',
      benefits: ['Global Tanınırlık', 'Şeffaflık Liderliği', 'Yatırımcı Güveni', 'Pazar Avantajı']
    },
    {
      title: 'Karbon Ayak İzi',
      category: 'measurement',
      description: 'ISO 14064-1 standardına uygun kurumsal karbon ayak izi hesaplama ve doğrulama hizmetleri.',
      image: 'https://readdy.ai/api/search-image?query=Carbon%20footprint%20measurement%20with%20environmental%20engineers%20using%20computers%20and%20CO2%20emission%20charts%20in%20professional%20office%20setting&width=400&height=200&seq=510&orientation=landscape',
      features: ['Scope 1,2,3 Hesaplama', 'ISO 14064-1', 'TÜV Doğrulama', 'Azaltım Stratejisi'],
      duration: '6-10 hafta',
      benefits: ['İklim Yönetimi', 'Maliyet Tasarrufu', 'Düzenleyici Uyum', 'Müşteri Talebi']
    },
    {
      title: 'Su Ayak İzi',
      category: 'measurement',
      description: 'Su kullanımınızı ölçerek su verimliliği için stratejiler geliştiriyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Water%20footprint%20assessment%20with%20environmental%20experts%20analyzing%20water%20usage%20data%20and%20conservation%20strategies%20in%20modern%20office&width=400&height=200&seq=511&orientation=landscape',
      features: ['Su Kullanım Analizi', 'Risk Değerlendirmesi', 'Verimlilik Stratejisi', 'Su Yönetim Planı'],
      duration: '4-8 hafta',
      benefits: ['Su Güvenliği', 'Maliyet Azaltma', 'Risk Yönetimi', 'Operasyonel Verimlilik']
    },
    {
      title: 'CBAM/SKDM Danışmanlığı',
      category: 'consulting',
      description: 'AB Sınırda Karbon Düzenleme Mekanizması için hazırlık ve uyum danışmanlığı.',
      image: 'https://readdy.ai/api/search-image?query=European%20Union%20CBAM%20carbon%20border%20adjustment%20mechanism%20consultation%20with%20trade%20experts%20and%20EU%20documentation&width=400&height=200&seq=512&orientation=landscape',
      features: ['CBAM Hazırlık', 'Karbon İçerik Hesaplama', 'AB Uyumluluk', 'İhracat Stratejisi'],
      duration: '6-12 hafta',
      benefits: ['AB İhracat Sürekliliği', 'Rekabet Avantajı', 'Düzenleyici Uyum', 'Maliyet Optimizasyonu']
    },
    {
      title: 'LCA Yaşam Döngüsü Analizi',
      category: 'measurement',
      description: 'Ürünlerinizin çevresel etkisini yaşam döngüsü boyunca analiz ediyoruz.',
      image: 'https://readdy.ai/api/search-image?query=Life%20cycle%20assessment%20LCA%20analysis%20with%20environmental%20scientists%20using%20SimaPro%20software%20and%20product%20lifecycle%20charts&width=400&height=200&seq=513&orientation=landscape',
      features: ['ISO 14040/14044', 'SimaPro Yazılımı', 'Cradle-to-Gate/Grave', 'Etki Kategorileri'],
      duration: '8-16 hafta',
      benefits: ['Ürün Optimizasyonu', 'Çevre Etkisi Azaltma', 'İnovasyon Rehberi', 'Pazarlama Avantajı']
    },
    {
      title: 'EPD Belgesi',
      category: 'certification',
      description: 'Ürünleriniz için Çevresel Ürün Beyannamesi (EPD) hazırlama ve sertifikasyon hizmetleri.',
      image: 'https://readdy.ai/api/search-image?query=Environmental%20Product%20Declaration%20EPD%20certificate%20with%20construction%20materials%20and%20green%20building%20certification%20in%20professional%20setting&width=400&height=200&seq=514&orientation=landscape',
      features: ['ISO 14025', 'PCR Uyumluluk', 'LCA Temelli', 'Üçüncü Taraf Doğrulama'],
      duration: '10-16 hafta',
      benefits: ['Yeşil Bina Puanları', 'B2B Güvenilirlik', 'İhracat Avantajı', 'Sürdürülebilir Tedarik']
    }
  ];

  const filteredServices = activeCategory === 'all' 
    ? services 
    : services.filter(service => service.category === activeCategory);

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20sustainability%20consulting%20services%20office%20with%20diverse%20team%20of%20experts%2C%20modern%20workspace%20with%20environmental%20charts%20and%20green%20technology%20displays&width=1200&height=600&seq=500&orientation=landscape)' 
          }}
        >
          <div className="absolute inset-0 bg-emerald-900/80"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
              Sürdürülebilirlik Hizmetlerimiz
            </h1>
            <p className="text-xl text-emerald-100 max-w-3xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
              16+ yıllık deneyimimizle uçtan uca sürdürülebilirlik danışmanlığı hizmetleri sunuyoruz. 
              300+ şirkete güvenilir çözümler sağlıyoruz.
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-white sticky top-16 z-40 border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-4">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`flex items-center space-x-2 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 ${
                    activeCategory === category.id
                      ? 'bg-emerald-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-600 hover:bg-emerald-50 hover:text-emerald-600'
                  }`}
                >
                  <i className={`${category.icon} text-lg`}></i>
                  <span>{category.name}</span>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    activeCategory === category.id
                      ? 'bg-white/20 text-white'
                      : 'bg-emerald-100 text-emerald-600'
                  }`}>
                    {category.id === 'all' ? services.length : services.filter(s => s.category === category.id).length}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredServices.map((service, index) => (
                <Card 
                  key={index} 
                  className="group hover:shadow-xl hover:scale-105 transition-all duration-300 animate-in fade-in slide-in-from-bottom-4 cursor-pointer overflow-hidden"
                  style={{ animationDelay: `${index * 100}ms` }}
                  onClick={() => window.open('/iletisim', '_self')}
                >
                  {/* Image */}
                  <div className="relative overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                      {service.duration}
                    </div>
                  </div>
                  
                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                      {service.title}
                    </h3>
                    
                    <p className="text-gray-600 mb-4 leading-relaxed text-sm">
                      {service.description}
                    </p>
                    
                    {/* Features */}
                    <div className="space-y-2 mb-6">
                      <h4 className="text-sm font-medium text-gray-900 mb-2">Ana Özellikler:</h4>
                      {service.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="flex items-center text-xs text-gray-600">
                          <i className="ri-check-line text-emerald-500 mr-2 text-sm"></i>
                          {feature}
                        </div>
                      ))}
                    </div>
                    
                    {/* Benefits */}
                    <div className="space-y-2 mb-6">
                      <h4 className="text-sm font-medium text-gray-900 mb-2">Faydalar:</h4>
                      <div className="grid grid-cols-2 gap-1">
                        {service.benefits.map((benefit, benefitIndex) => (
                          <div key={benefitIndex} className="text-xs text-emerald-600 bg-emerald-50 px-2 py-1 rounded">
                            {benefit}
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    {/* CTA Button */}
                    <Button 
                      size="sm" 
                      className="w-full group-hover:bg-emerald-700 transition-colors whitespace-nowrap"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsQuoteModalOpen(true);
                      }}
                    >
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                      Teklif Al
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section 
          className="relative py-20 bg-cover bg-center overflow-hidden"
          style={{ 
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20sustainable%20business%20environment%20with%20green%20energy%20elements%2C%20modern%20office%20with%20solar%20panels%20and%20wind%20turbines%20in%20background%2C%20corporate%20sustainability%20concept%20with%20natural%20lighting%20and%20eco-friendly%20design%2C%20clean%20minimal%20professional%20setting&width=1200&height=600&seq=400&orientation=landscape)' 
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/90 via-emerald-800/85 to-emerald-700/80"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
          
          {/* Floating Elements */}
          <div className="absolute inset-0 overflow-hidden opacity-10">
            <div className="absolute top-10 left-10 w-20 h-20 border-2 border-white rounded-full animate-pulse"></div>
            <div className="absolute top-32 right-20 w-16 h-16 border border-white rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
            <div className="absolute bottom-20 left-1/4 w-12 h-12 border border-white rounded-full animate-ping" style={{ animationDelay: '2s' }}></div>
            <div className="absolute bottom-32 right-1/3 w-8 h-8 bg-white rounded-full animate-pulse" style={{ animationDelay: '3s' }}></div>
          </div>

          <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="animate-in fade-in slide-in-from-bottom-8 duration-1000">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                Hangi Hizmetimizle Başlamak İstiyorsunuz?
              </h2>
              <p className="text-xl md:text-2xl text-emerald-100 mb-10 max-w-4xl mx-auto leading-relaxed">
                Uzman ekibimizle ücretsiz danışmanlık alın ve projenize en uygun çözümü belirleyin
              </p>
              
              {/* Benefits Grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
                <div className="flex items-center justify-center space-x-3 text-emerald-100 animate-in fade-in slide-in-from-left duration-1000 delay-500">
                  <div className="w-10 h-10 bg-emerald-500/30 backdrop-blur-sm rounded-full flex items-center justify-center border border-emerald-400/30">
                    <i className="ri-check-line text-emerald-200"></i>
                  </div>
                  <span className="font-medium">Ücretsiz İlk Konsültasyon</span>
                </div>
                <div className="flex items-center justify-center space-x-3 text-emerald-100 animate-in fade-in slide-in-from-bottom duration-1000 delay-700">
                  <div className="w-10 h-10 bg-emerald-500/30 backdrop-blur-sm rounded-full flex items-center justify-center border border-emerald-400/30">
                    <i className="ri-team-line text-emerald-200"></i>
                  </div>
                  <span className="font-medium">16+ Yıl Deneyim</span>
                </div>
                <div className="flex items-center justify-center space-x-3 text-emerald-100 animate-in fade-in slide-in-from-right duration-1000 delay-900">
                  <div className="w-10 h-10 bg-emerald-500/30 backdrop-blur-sm rounded-full flex items-center justify-center border border-emerald-400/30">
                    <i className="ri-award-line text-emerald-200"></i>
                  </div>
                  <span className="font-medium">300+ Başarılı Proje</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-6 justify-center animate-in fade-in slide-in-from-bottom duration-1000 delay-1100">
                <button
                  onClick={() => window.open('https://calendly.com/ecoventra', '_blank')}
                  className="group bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white hover:bg-white hover:text-emerald-700 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 whitespace-nowrap hover:scale-105 hover:shadow-xl hover:shadow-white/20"
                >
                  <div className="w-6 h-6 flex items-center justify-center mr-3 inline-flex">
                    <i className="ri-calendar-line group-hover:scale-110 transition-transform"></i>
                  </div>
                  Ücretsiz Randevu Al
                </button>
                
                <button
                  onClick={() => window.open('https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, sürdürülebilirlik danışmanlığı hizmetleriniz hakkında bilgi almak istiyorum.', '_blank')}
                  className="group bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 whitespace-nowrap hover:scale-105 hover:shadow-xl hover:shadow-green-500/30 border-2 border-green-500"
                >
                  <div className="w-6 h-6 flex items-center justify-center mr-3 inline-flex">
                    <i className="ri-whatsapp-line group-hover:scale-110 transition-transform"></i>
                  </div>
                  WhatsApp ile İletişim
                </button>
              </div>

              {/* Contact Info */}
              <div className="mt-10 pt-8 border-t border-white/20">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-emerald-100">
                  <div className="flex items-center space-x-2">
                    <i className="ri-phone-line text-emerald-300"></i>
                    <span className="text-sm">+90 543 437 30 49</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-mail-line text-emerald-300"></i>
                    <span className="text-sm">info@ecoventra.com</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-time-line text-emerald-300"></i>
                    <span className="text-sm">7/24 Destek</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Quote Modal */}
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
}
